import { getTranslation } from '@services/translations';

export const LayoutVariant = { DND: 'DRAG_AND_DROP', DROPDOWN: 'DROPDOWN' };

export const legacyTranslations = () =>
  ({
    // Never used.
    DRAG_AND_DROP_USAGE: getTranslation(
      'survey.ranking-questions.DRAG_AND_DROP_USAGE',
      'Use Down Arrow and Up Arrow to move between items. Press Spacebar to reorder.'
    ),

    GRABBED_ITEM_DROP: getTranslation(
      'survey.ranking-questions.GRABBED_ITEM_DROP',
      '%s, dropped. Final position in list: %s of %s.'
    ),

    GRABBED_ITEM_MOVE: getTranslation(
      'survey.ranking-questions.GRABBED_ITEM_MOVE',
      '%s. Current position in list: %s of %s.'
    ),

    ITEM_GRABBED: getTranslation(
      'survey.ranking-questions.ITEM_GRABBED',
      '%s, grabbed. Current position in list: %s of %s. Press up and down arrow keys to change position, Spacebar to drop, Escape key to cancel.'
    ),

    RANK_ITEM: getTranslation('survey.ranking-questions.RANK_ITEM', 'Updated, %s, Rank %s.'),

    REORDER_CANCELED: getTranslation(
      'survey.ranking-questions.REORDER_CANCELED',
      '%s. Reorder cancelled.'
    ),

    UNRANK_ITEM: getTranslation('survey.ranking-questions.UNRANK_ITEM', 'Updated, %s, Unranked.')
  }) as const;
